import { SnackbarSliceState, SnackbarState, SnackbarType } from '@/interface/snackbar.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: SnackbarSliceState = {
  snackbars: []
};

interface ShowSnackbarPayload {
  message: string;
  type?: SnackbarType;
  duration?: number;
}

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<ShowSnackbarPayload>) => {
      const { message, type = 'info', duration = 4000 } = action.payload;
      const id = Math.random().toString(36).substr(2, 9);
      
      const newSnackbar: SnackbarState = {
        id,
        message,
        type,
        duration
      };
      
      state.snackbars.push(newSnackbar);
    },
    
    hideSnackbar: (state, action: PayloadAction<string>) => {
      state.snackbars = state.snackbars.filter(
        snackbar => snackbar.id !== action.payload
      );
    },
    
    clearAllSnackbars: (state) => {
      state.snackbars = [];
    }
  }
});

export const { showSnackbar, hideSnackbar, clearAllSnackbars } = snackbarSlice.actions;
export default snackbarSlice.reducer;